import {
  ALOE_100,
  CHARCOAL_100,
  MOSS_50,
  OwnUpBody,
  PropsWithTheme,
  OwnUpGridWrapper,
  OwnUpHeadlineBook,
  OwnUpFillButtonPrimary
} from '@rategravity/own-up-component-library';
import React from 'react';
import styled from 'styled-components';

export const CTAButton1Wrapper = styled(OwnUpGridWrapper)`
  border: 1px solid #84cdaa;
  border-radius: 8px;
  padding-top: 40px;
  padding-bottom: 40px;
  text-align: center;
  margin-top: 40px;
  margin-bottom: 40px;
  margin-left: 0px;
  margin-right: 0px;
  ${({ theme }: PropsWithTheme<{}>) => theme.breakpoints.down('sm')} {
    padding: 24px 16px;
  }
`;

export const CTAHeadlineText = styled(OwnUpHeadlineBook)`
  font-size: 40px;
  padding-bottom: 30px;
  padding-top: 0px !important;
  ${({ theme }: PropsWithTheme<{}>) => theme.breakpoints.down('sm')} {
    padding-bottom: 20px;
    font-size: 30px;
    margin-left: 24px !important;
    margin-right: 24px !important;
  }
`;

const Button = styled.a`
  align-items: center;
  background-color: ${MOSS_50};
  color: ${CHARCOAL_100};
  border: 2px solid transparent;
  border-radius: 8px;
  text-decoration: none;
  display: flex;
  flex-direction: row;
  height: 112px;
  padding: 20px;
  text-align: left;
  width: 100%;
  &:hover {
    cursor: pointer;
  }
  &:focus {
    outline-style: unset;
  }
  &[data-focus-visible-added] {
    border: 2px solid ${ALOE_100};
    border-radius: 8px;
    outline: none;
  }
`;

const Icon = styled.div`
  margin-right: 24px;
  background-color: ${MOSS_50};
  width: 61px;
  display: flex;
  place-content: center;
  border-radius: 8px;
`;

export interface IconButton {
  id?: string;
  icon: any;
  text: string;
  href: string;
  trackingEvent?: string;
}

export const CTAIconButton = ({ id, icon, text, href }: IconButton) => {
  return (
    <Button id={id} href={href}>
      <Icon>{icon}</Icon>
      <OwnUpBody
        style={{ fontSize: '20px', fontWeight: 'bold', paddingTop: '0px' }}
        variant={'body1'}
      >
        {text}
      </OwnUpBody>
    </Button>
  );
};

export const CTAButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding-top: ${({ theme }) => theme.spacing(4)}px;
  ${({ theme }) => theme.breakpoints.up('lg')} {
    padding-top: ${({ theme }) => theme.spacing(5)}px;
  }
  ${({ theme }) => theme.breakpoints.down('sm')} {
    padding-top: ${({ theme }) => theme.spacing(3)}px;
  }
`;

export const CTAButtonLink = styled.a`
  color: ${({ theme }: PropsWithTheme<{}>) => theme.underlineLinkColors.linkFontColor};
  text-decoration: none;
`;

export const CTAButtonLinkText = styled(OwnUpFillButtonPrimary)`
  p {
    padding: 0px !important;
    margin-top: 16px !important;
    margin-bottom: 16px !important;
  }
`;
